<form [formGroup]="NomineeForm" (ngSubmit)="Submit(NomineeForm)" novalidate>
    <h1 mat-dialog-title>{{title}}</h1>
    <div mat-dialog-content>
        <div [innerHTML]="message | safeHTML"></div>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>First Name</span></div>
            <mat-form-field appearance="outline" fxFlex="25">
                <input type="text" matInput placeholder="First Name" formControlName="FirstName" required />
                <mat-error *ngIf="NomineeForm.get('FirstName')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="NomineeForm.get('FirstName')?.hasError('maxlength')">name too long</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Last Name</span></div>
            <mat-form-field appearance="outline" fxFlex="25">
                <input type="text" matInput placeholder="Last Name" formControlName="LastName" required />
                <mat-error *ngIf="NomineeForm.get('LastName')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="NomineeForm.get('LastName')?.hasError('maxlength')">name too long</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div><span>Email</span></div>
            <mat-form-field appearance="outline" fxFlex="25">
                <input type="text" matInput placeholder="Email" formControlName="Email" required />
                <mat-error *ngIf="NomineeForm.get('Email')?.hasError('required')">required</mat-error>
                <mat-error *ngIf="NomineeForm.get('Email')?.hasError('maxlength')">email too long</mat-error>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">{{canceltext}}</button>
        <button mat-raised-button type="submit" [color]="'primary'">{{oktext}}</button>
    </div>
</form>